<template>
  <div class="w-full">
    <UiDialog
      :model-value="searchIsOpen"
      :position="isMdAndUp ? 'center' : 'bottom'"
      :z-index="30"
      @update:model-value="closeSearch"
    >
      <template #default="{ height, numberHeight }">
        <SearchModal
          v-if="searchIsOpen"
          :style="{ height: isMdAndUp ? `${numberHeight - 52}px` : height }"
          @close="closeSearch"
        />
      </template>
    </UiDialog>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { defineAsyncComponent, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useReloadOnConfigurationUpdate } from '@/5_entities/Configuration'
import { useSearch } from '@/5_entities/Search'
import { useQueryParamsOpenState } from '@/6_shared/composables'
import { useBreakpoint } from '@/6_shared/lib'
import { UiDialog } from '@/6_shared/ui'

const SearchModal = defineAsyncComponent(async () => {
  const { SearchModal } = await import('@/3_widgets/Search')

  return SearchModal
})
const {
  md: [isMdAndUp]
} = useBreakpoint()
const { closeSearch, openSearch } = useSearch()
const { searchIsOpen } = storeToRefs(useSearch())

useReloadOnConfigurationUpdate(() => {
  closeSearch()
})

const route = useRoute()
const { setParamInRouteQuery } = useQueryParamsOpenState('search', () => {
  // внутри открываются другие модалки.
  // так что нужно проверять, что закрылись именно они, а не текущая
  if (searchIsOpen.value && !route.query?.search) {
    closeSearch()
  }

  if (route.query?.search) {
    openSearch()
  }
})

watch(
  () => searchIsOpen.value,
  (val) => {
    if (val) setParamInRouteQuery('open')
  }
)
</script>
